export function exportVendorsToCSV(vendorsList) {
    if (!Array.isArray(vendorsList) || vendorsList.length === 0) {
        console.warn("exportVendorsToCsv: no data to export.");
        return;
    }

    const rawKeys = Object.keys(vendorsList[0]);

    const idIndex = rawKeys.indexOf("id");
    if (idIndex > -1) {
        rawKeys.splice(idIndex, 1);
        rawKeys.unshift("id");
    }

    const headerRow = rawKeys.join(",") + "\r\n";

    const rows = vendorsList.map((vendor) => {
        return rawKeys
            .map((key) => {
                if (key === "contact_phone_number") {
                    const rawVal = vendor[key];
                    if (rawVal == null || rawVal === "") {
                        return "";
                    }
                    const asNumber = Number(rawVal);
                    if (isNaN(asNumber)) {
                        return "";
                    }
                    return String(Math.trunc(asNumber));
                }
                let cell = vendor[key] != null ? String(vendor[key]) : "";
                if (/[",\r\n]/.test(cell)) {
                    cell = `"${cell.replace(/"/g, '""')}"`;
                }
                return cell;
            })
            .join(",");
    });

    const csvContent = headerRow + rows.join("\r\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "vendors.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
}

function isIsoDatetime(str) {
    return /^\d{4}-\d{2}-\d{2}T/.test(str);
}

function formatDateTime(isoString) {
    if (!isoString) return "";
    const dt = new Date(isoString);
    if (isNaN(dt)) return String(isoString);
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    const hh = String(dt.getHours()).padStart(2, "0");
    const min = String(dt.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
}


